import { snakeToTitleCase } from "./tools";

/** Props-driven auditor tables: no API calls or Vuex; optional client-side pagination. */
export default {
  data() {
    return {
      dataList: [],
      perPageCount: 50,
      current_page: 1,
      page_size: 50,
    };
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    pageSizeNum() {
      const n = parseInt(this.perPageCount, 10);
      return Number.isFinite(n) && n > 0 ? n : 50;
    },
    total_items() {
      return Array.isArray(this.dataList) ? this.dataList.length : 0;
    },
    paginatedData() {
      const list = Array.isArray(this.dataList) ? this.dataList : [];
      const size = this.pageSizeNum;
      const start = (this.current_page - 1) * size;
      return list.slice(start, start + size);
    },
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.dataList = Array.isArray(newVal) ? [...newVal] : [];
        this.current_page = 1;
      },
      deep: true,
      immediate: true,
    },
    perPageCount(newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal, 10) || 50;
    },
  },
  methods: {
    changePage(page) {
      this.current_page = page;
    },
    convertText(t) {
      return snakeToTitleCase(t);
    },
  },
};
